//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(["errors", "menu", "location"]),
    itemImageUrl() {
      const imageUrl = this.item.images.find(image => image.groupname === "mobile-webapp-menu")?.filename
      return imageUrl || this.item.images[2].filename || this.item.images[3].filename
    }
  },
  methods: {
    viewProduct(item, cid) {
      window.dataLayer.push({
        event: "select_item",
        ecommerce: {
          location_code: this.location ? this.location.id : 'default',
          location_name: this.location ? this.location.name : 'default',
          item_list_id: this.category?.id,
          item_list_name: this.category?.name,
          items: [{
            item_id: this.item.id,
            item_name: this.item.name,
          }],
        }
      })

      let link = {};
      if (this.menu) {
        link = "/order/product?id=" + item.sku + "&cat=" + cid;
      } else {
        link = "/menu/product/" + item.sku;
      }
      this.$router.push(link);
    },
    async quickAdd(item) {
      await this.$store.dispatch("product/clearProduct");
      await this.$store.dispatch("product/getProduct", {
        id: item.sku,
        defaults: [],
        quantities: []
      });
      await this.$store.dispatch("product/addToCart", {
        id: item.id,
        itemType: 'Quick Add'
      });
      if (this.errors.length == 0) {
        this.$store.commit("setShowCart", true);
        this.$store.dispatch("product/clearProduct");
      }
    }
  }
};
